import CSidebar from "@/components/c-sidebar/index.vue";
import CNavbar from "@/components/c-navbar/index.vue";

import C404 from "@/components/errors/c-404/index.vue";
import CEmpty from "@/components/errors/c-empty/index.vue";
import CResult from "@/components/errors/c-result/index.vue";
import CInternet from "@/components/errors/c-internet/index.vue";
import CSoon from "@/components/errors/c-soon/index.vue";

import CImg from "@/components/shared/c-img/index.vue";
import CInput from "@/components/shared/c-input/index.vue";
import CsInput from "@/components/shared/cs-input/index.vue";
import CButton from "@/components/shared/c-button/index.vue";
import CLoading from "@/components/shared/c-loading/index.vue";
import CTextarea from "@/components/shared/c-textarea/index.vue";
import CSelect from "@/components/shared/c-select/index.vue";
import CMultiSelect from "@/components/shared/c-multi-select/index.vue";
import CTable from "@/components/shared/c-table/index.vue";
import CTab from "@/components/shared/c-tab/index.vue";
import CModal from "@/components/shared/c-modal/index.vue";
import CMeta from "@/components/shared/c-meta/index.vue";
import CSwitch from "@/components/shared/c-switch/index.vue";
import CFilter from "@/components/shared/c-filter-button/index.vue";
import CSelectCreate from "@/components/shared/c-select-create/index.vue";
import CMultiCheckbox from "@/components/shared/c-multi-checkbox/index.vue";
import CMedia from "@/components/shared/c-media/index.vue";
import CIcon from "@/components/shared/c-icon/index.vue";
import CDynamicTab from "@/components/shared/c-dynamic-tab/index.vue";
import CMultiCheck from "@/components/shared/c-multi-check/index.vue";
import CListSearch from "@/components/shared/c-list-search/index.vue";
import CItemName from "@/components/shared/c-item-name/index.vue";
import CPreviewDocument from "@/components/shared/c-preview-document/index.vue";

export const components = [
  { name: "c-sidebar", component: CSidebar },
  { name: "c-navbar", component: CNavbar },

  { name: "c-404", component: C404 },
  { name: "c-empty", component: CEmpty },
  { name: "c-result", component: CResult },
  { name: "c-internet", component: CInternet },
  { name: "c-soon", component: CSoon },

  { name: "c-img", component: CImg },
  { name: "c-input", component: CInput },
  { name: "cs-input", component: CsInput },
  { name: "c-button", component: CButton },
  { name: "c-loading", component: CLoading },
  { name: "c-textarea", component: CTextarea },
  { name: "c-select", component: CSelect },
  { name: "c-multi-select", component: CMultiSelect },
  { name: "c-tab", component: CTab },
  { name: "c-table", component: CTable },
  { name: "c-multi-check", component: CMultiCheck },

  { name: "c-modal", component: CModal },
  { name: "c-meta", component: CMeta },
  { name: "c-switch", component: CSwitch },
  { name: "c-filter", component: CFilter },
  { name: "c-select-create", component: CSelectCreate },
  { name: "c-multiple-checkbox", component: CMultiCheckbox },
  { name: "c-media", component: CMedia },
  { name: "c-icon", component: CIcon },
  { name: "c-dynamic-tab", component: CDynamicTab },
  { name: "c-list-search", component: CListSearch },
  { name: "c-item-name", component: CItemName },
  { name: "c-preview-document", component: CPreviewDocument },
];
